













import {Component, Prop, Vue} from 'vue-property-decorator';

/**
 * @status stable
 * @published $next
 * @changelog $next Published.
 */
@Component
export default class JdhValidationProvider extends Vue {
    @Prop() vid!: string
    @Prop({default: () => {return {}}}) rules!: {[key: string]: any}
    @Prop({default: false, type: Boolean}) aggressive!: boolean

    get normalizedRules() {
        return Object.keys(this.rules).reduce((prev: {[key: string]: any}, cur: string) => {
            return {... prev, ... {[`jdsv_${cur}`]: this.rules[cur]}};
        }, {})
    }

    errorCode(failedRules: {[key: string]: string}): {[key: string]: true} {
        if (!failedRules || Object.keys(failedRules).length === 0) return {}
        return {[Object.keys(failedRules)[0].replaceAll('jdsv_', '')]: true}
    }
}
